import { Module } from 'vuex';
import { JobExecutionHistoryState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: JobExecutionHistoryState = {
    lists: undefined,
    count: 0,
    details: undefined,
    searchSelectItems: undefined,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    searchSelect: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    retry: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const jobExecutionHistory: Module<JobExecutionHistoryState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
